module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "localness",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "localness"
    }
  }, [_c('h3', [_vm._v("What do people talk about on Twitter in " + _vm._s(_vm.store.state.currentNeighborhood))]), _vm._v("\n  These are terms that are used more often in " + _vm._s(_vm.store.state.currentNeighborhood) + " than in other neighborhoods. Click each word for context.\n  "), _c('ul', _vm._l((_vm.top10TweetTfidf), function(tweetword) {
    return _c('li', [_c('span', {
      on: {
        "click": function($event) {
          return _vm.expandTweetWord(tweetword['word'])
        }
      }
    }, [_vm._v(_vm._s(tweetword['word']))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.expanded.indexOf(tweetword['word']) >= 0),
        expression: "expanded.indexOf(tweetword['word']) >= 0"
      }]
    }, [_c('ul', _vm._l((tweetword['context']), function(sentence) {
      return _c('li', [_vm._v("\n          " + _vm._s(sentence) + "\n          ")])
    }), 0)])])
  }), 0), _vm._v(" "), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0053b21a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Localness.vue
// module id = 167
// module chunks = 1